import { render, staticRenderFns } from "./postoperative.vue?vue&type=template&id=6cc5a328&scoped=true&"
import script from "./postoperative.vue?vue&type=script&lang=js&"
export * from "./postoperative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc5a328",
  null
  
)

export default component.exports